import { observer } from 'mobx-react-lite'

import { CommentsFeed } from '@/Ship/Components/Comments'
import { FieldSection, SectionEmpty } from '@/Ship/Components/EntityCard'

import { crmOwnerOf } from '../Owner/CrmOwnerFormContext'

import type { CrmOwnerFormContextLike } from '../Owner/CrmOwnerFormContext'

export interface CrmCommentsAsideProps {
    /** Колекція коментарів власника: `/services/client_comments` */
    restUrl: string
    /** Поле власника в коментарі: `client`, `contact` */
    ownerField: string
    formContext: CrmOwnerFormContextLike | undefined
    /** Що показати на місці стрічки у формі створення */
    unsavedText: string
}

/**
 * Блок «Коментарі» праворуч у картці власника CRM (`SPEC-008` §5.8, §7.1):
 * Ship `CommentsFeed` у білій плашці картки.
 *
 * Форму показує `_permissions.comment` власника — бек дає його тим, хто бачить
 * запис і має роль за матрицею, і забирає на видаленому власнику. У формі
 * створення стрічки ще немає — на її місці пояснення, коли вона з'явиться.
 *
 * Окремий observer: шаблон картки службових значень не читає, а стрічка не
 * перемонтовується разом із ним — чернетка коментаря не губиться.
 */
export const CrmCommentsAside = observer(({ restUrl, ownerField, formContext, unsavedText }: CrmCommentsAsideProps) => {
    const owner = crmOwnerOf(formContext)

    return (
        <FieldSection title="Коментарі">
            {owner ? (
                <CommentsFeed
                    restUrl={restUrl}
                    ownerField={ownerField}
                    ownerUuid={owner.uuid}
                    ownerIri={owner['@id']}
                    canComment={formContext?.values?._permissions?.comment === true}
                />
            ) : (
                <SectionEmpty>{unsavedText}</SectionEmpty>
            )}
        </FieldSection>
    )
})
